/**
 * Feature announcements — the single place to add a "what's new" notice.
 *
 * Each entry renders, for its audience, as a red "NEW" chip in the header with a
 * speech bubble carrying the text (see `FeatureAnnounce`). Dismissing (×) hides
 * it for that user forever (localStorage). To announce a new feature, add ONE
 * entry here with a fresh `id`. Keep the list short — prune old ones once they've
 * been seen.
 */

import type { User as UserDoc } from '@daaily/shared';

export interface Announcement {
  /** Stable, unique — used as the per-user dismiss key. Bump to re-show. */
  id: string;
  title: string;
  body: string;
  /** Shown only when this returns true for the signed-in user. */
  audience: (user: UserDoc) => boolean;
}

const hasInvoices = (u: UserDoc) => !!u.tools?.invoices?.enabled;

export const ANNOUNCEMENTS: Announcement[] = [
  {
    id: 'hub-new-look-2026-09',
    title: 'The HR Hub has a new look',
    body:
      'It now follows your device’s light or dark setting. To pick Light, Dark or System yourself, ' +
      'open the menu under your name at the bottom of the sidebar (on a phone: your photo, top right).',
    audience: () => true,
  },
  {
    id: 'invoice-ai-prefill-2026-06',
    title: 'AI now fills in your invoice for you',
    body:
      'Start a new invoice submission and drop your invoice PDF — we read it and pre-fill the ' +
      'number, amount, currency and date for you to check. And you no longer need to combine your ' +
      'invoice and expense into one PDF beforehand: drop each in its own box and we’ll merge them ' +
      'on submit. Prefer to type it in yourself? Use “Skip and fill in manually”.',
    audience: hasInvoices,
  },
];
